import { FC, useContext } from "react"

/** Components */
import { SideRailContext } from "../../SideRail/SideRailContext"
import { Dispatch } from "redux"
import { tContext } from "../types"
import { iTKExportFormat } from "../../../cached-data/types"
import { iMutableFilterState, tFilterDef, tFilterState } from "../../../filters/types"

/** Types */
type Props = {
    data: Record<string, any>
    config: Record<string, any>
    context: tContext
    dispatch: Dispatch<any>
    exportFormat: iTKExportFormat
    filters: tFilterState
    sideRailSettings: Record<string, any>
    weeklyViewFilters: tFilterDef[]
}

const RerunExportCellRenderer: FC<Props> = props => {
    const { enableSideRail } = useContext(SideRailContext)
    const filters: iMutableFilterState = {}
    const flattenedFilters = Object.entries(props.data.filters).reduce((agg, entry) => {
        const [queryParam, value] = entry
        if (queryParam.endsWith("_custom")) {
            const model = queryParam.split("_custom")[0]
            Object.entries(value as Record<string, string>).forEach(([k, v]) => {
                const key = `companyTextFieldOptions-${
                    String(model).charAt(0).toUpperCase() + String(model).slice(1)
                }-${k}`
                agg[key] = v
            })
        } else {
            agg[queryParam] = value
        }
        return agg
    }, {} as Record<string, any>)

    Object.entries(flattenedFilters).forEach(([queryParam, value]) => {
        // Find the filter for this key
        let filter = props.weeklyViewFilters.find(f => f.parameterName === queryParam)
        // special handling for custom filters
        if (!filter) {
            filter = props.weeklyViewFilters.find(f => f.key === queryParam)
        }
        if (!filter) {
            return
        }
        const key: keyof iMutableFilterState = filter.key
        filters[key] = value as any
    })
    const openRightRail = () => {
        enableSideRail({
            flow: "RUN_EXPORT",
            selectedExports: [props.exportFormat],
            initialFilters: filters,
            cameFrom: "history",
        })
    }
    return (
        <button onClick={openRightRail} id={props.data.buttonId} type="button" className="action-button">
            <div>{"View Details"}</div>
        </button>
    )
}

export default RerunExportCellRenderer
